import { render, staticRenderFns } from "./NotificationFeed.vue?vue&type=template&id=39470e30"
import script from "./NotificationFeed.vue?vue&type=script&lang=js"
export * from "./NotificationFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports